// @flow
import React, { type Node } from 'react';
import compose from 'recompose/compose';
import classNames from 'classnames/bind';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import nope from 'app/common/lib/nope';
import { useTranslation } from 'react-i18next';

import styles from './Confirmation.scss';

const cx = classNames.bind(styles);

const enhance = compose(
  withState('opened', 'setOpened', false),
  withState('loading', 'setLoading', false),

  withHandlers({
    show: ({ setOpened, beginConfirmation }) => (e) => {
      e.preventDefault();
      if (beginConfirmation) {
        beginConfirmation(e);
      }
      setOpened(true);
    },
    cancel: ({ setOpened, stopConfirmation }) => (e) => {
      e.preventDefault();
      if (stopConfirmation) {
        stopConfirmation();
      }
      setOpened(false);
    },
    handleSubmit: ({ onSubmit, setOpened, stopConfirmation, setLoading }) => async (e) => {
      setLoading(true);
      if (typeof onSubmit === 'function') {
        await onSubmit(e);
      }
      if (stopConfirmation) {
        stopConfirmation();
      }
      setOpened(false);
      setLoading(false);
    },
  })

);

type Props = {
  children: (Function) => Node,
  onSubmit: (e: SyntheticEvent<HTMLElement>) => void,
  show: (e: SyntheticEvent<HTMLElement>) => void,
  cancel: (e: SyntheticEvent<HTMLElement>) => void,
  handleSubmit: (e: SyntheticEvent<HTMLElement>) => void,
  opened: boolean,
  submitText: string,
  cancelText: string,
  comment?: string,
  beginConfirmation?: (e: SyntheticEvent<HTMLElement>) => void,
  stopConfirmation?: (void) => void,
  name?: string,
  className?: string,
  loading: boolean,
  injectPrice?: Node,
};

const Confirmation = ({
  children,
  handleSubmit,
  show,
  opened,
  cancel,
  submitText: st,
  cancelText: ct,
  comment,
  name,
  className,
  loading,
  injectPrice,
}: Props) => {
  const { t } = useTranslation('tariff');
  const submitText = st || t('confirmation_default_submit_bt');
  const cancelText = ct || t('confirmation_default_cancel_bt');

  const commentSplitted = injectPrice && comment ? comment.split('{inject_price}') : [];

  return (
    opened
      ? <div className={classNames(styles.root, className)}>
        {comment && !injectPrice && <div>{comment}</div>}
        {comment && injectPrice && commentSplitted.length === 2
          && <div>
            {commentSplitted[0]}
            {injectPrice}
            {commentSplitted[1]}
          </div>}
        <a
          href="yes"
          className={cx({ primary: true, loading })}
          onClick={loading ? nope : handleSubmit}
          name={name}
        >
          {submitText}
        </a>

        <a
          href="cancel"
          onClick={loading ? nope : cancel}
          className={cx({ loading })}
        >
          {cancelText}
        </a>
      </div>
      : children(show)
  );
};

export default enhance(Confirmation);
